/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Recorded GDPR consent returned in run state.
 */
export interface OralExamConsentRecord {
  subject: string;
  grantedAt: string;
  policyVersion: string;
  scope: string;
}
